var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    { staticClass: "fill", attrs: { "title-color": "primary" } },
    [
      _c(
        "template",
        { slot: "actions" },
        [
          _c(
            "vs-dropdown",
            { staticStyle: { "margin-left": "15px" } },
            [
              _c(
                "a",
                { staticClass: "a-icon", attrs: { href: "#" } },
                [
                  _vm._v(" Repositorio: "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.selectedRepository.nombreRepositorio))
                  ]),
                  _c("vs-icon", { attrs: { icon: "expand_more" } })
                ],
                1
              ),
              _c(
                "vs-dropdown-menu",
                _vm._l(_vm.repositories, function(repo) {
                  return _c(
                    "vs-dropdown-item",
                    {
                      key: repo.repositorioId,
                      staticStyle: { width: "200px" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.selectRepository(repo)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(repo.nombreRepositorio) + " ")]
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("filtros", {
        ref: "filtros",
        attrs: {
          "content-show": "",
          "content-field": "content",
          "configuracion-vista": _vm.configuration,
          periodos: _vm.periodos
        },
        on: { "filtros-aplicados": _vm.handleFilters }
      }),
      _c("div", {
        staticStyle: {
          clear: "both",
          "border-bottom": "solid 1px #ccc",
          "margin-bottom": "10px"
        }
      }),
      _vm.firstSearch
        ? _c("div", { staticClass: "message" }, [
            _vm._v(
              ' Para realizar una búsqueda agrega algunos filtros y luego presiona el boton "Aplicar Filtros" arriba a la izquierda. '
            )
          ])
        : _vm._e(),
      _vm.noResults
        ? _c("div", { staticClass: "message" }, [
            _vm._v(
              " Oh no! no logramos encontrar nada con los filtros que ingresaste, verificalos o prueba quitando algunos. "
            )
          ])
        : _vm._e(),
      _vm.loading
        ? _c("div", { staticClass: "message" }, [
            _vm._v(
              " Buscando en el repositorio los elementos que coincidan con los filtros de busqueda ingresados... "
            )
          ])
        : _vm._e(),
      _vm._l(_vm.result, function(item) {
        return _c("div", { key: "object-" + item.id, staticClass: "result" }, [
          _c(
            "div",
            { staticClass: "kind" },
            [
              item.tipoObjeto === _vm.elementTipe.FOLDER
                ? _c("font-awesome-icon", {
                    staticClass: "icon-folder",
                    attrs: { icon: ["fas", "folder"] }
                  })
                : _vm._e(),
              item.tipoObjeto === _vm.elementTipe.FILE
                ? _c("font-awesome-icon", {
                    staticClass: "icon-file",
                    class: _vm.fileTypeIcon({
                      mime: item.mime,
                      name: item.nombre
                    }),
                    attrs: {
                      icon: [
                        "fas",
                        _vm.fileTypeIcon({ mime: item.mime, name: item.nombre })
                      ]
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "detail" }, [
            _c("div", { staticClass: "actions" }, [
              item.tipo === "file"
                ? _c(
                    "div",
                    {
                      staticClass: "action",
                      on: {
                        click: function($event) {
                          return _vm.download(item)
                        }
                      }
                    },
                    [
                      _vm._v(" Descargar "),
                      _c("font-awesome-icon", {
                        staticClass: "action-icon",
                        attrs: { icon: ["fas", "download"] }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "action",
                  on: {
                    click: function($event) {
                      return _vm.goTo(item)
                    }
                  }
                },
                [
                  _vm._v(" Ver "),
                  _c("font-awesome-icon", {
                    staticClass: "action-icon",
                    attrs: { icon: ["fas", "arrow-right"] }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "name" }, [_vm._v(_vm._s(item.nombre))]),
            _c("div", { staticClass: "keywords" }, [
              _c("span", [_vm._v("Keywords:")]),
              _vm._v(" " + _vm._s(_vm.safeJoin(item.keywords, ", ")))
            ]),
            _c(
              "div",
              { staticClass: "tags" },
              [
                _c("span", [_vm._v("Tags:")]),
                _vm._l(item.tags, function(tag) {
                  return _c("div", { key: "tag-" + tag, staticClass: "tag" }, [
                    _vm._v(_vm._s(tag))
                  ])
                })
              ],
              2
            ),
            _c("div", { staticClass: "ruta" }, [
              _c("span", [_vm._v("Ruta:")]),
              _vm._v(" " + _vm._s(item.path || "/") + " ")
            ])
          ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }